import React, {ComponentType, memo, SVGProps} from 'react';

import {Box} from '@mui/material';
import {useTranslation} from 'react-i18next';

import {CoParentFamilyIcon, CoParentLockIcon} from './icons';

interface Benefit {
  id: string;
  Icon: ComponentType<SVGProps<SVGSVGElement>>;
  titleKey: string;
  descriptionKey: string;
}

const BENEFITS: Benefit[] = [
  {
    id: 'finances',
    Icon: CoParentFamilyIcon,
    titleKey: 'co_parent.invitation.benefit_finances_title',
    descriptionKey: 'co_parent.invitation.benefit_finances_description',
  },
  {
    id: 'independent',
    Icon: CoParentLockIcon,
    titleKey: 'co_parent.invitation.benefit_independent_title',
    descriptionKey: 'co_parent.invitation.benefit_independent_description',
  },
];

export const CoparentBenefits = memo(() => {
  const {t} = useTranslation();

  return (
    <Box className="co-parent-benefits">
      {BENEFITS.map(({id, Icon, titleKey, descriptionKey}) => (
        <Box
          key={id}
          className="co-parent-benefit">
          <Box className="co-parent-benefit__icon">
            <Icon />
          </Box>
          <Box className="co-parent-benefit__content">
            <p className="co-parent-benefit__title">{t(titleKey)}</p>
            <p className="co-parent-benefit__description">
              {t(descriptionKey)}
            </p>
          </Box>
        </Box>
      ))}
    </Box>
  );
});

CoparentBenefits.displayName = 'CoparentBenefits';
